module.exports = __webpack_public_path__ + "img/customerservice.6e815211.png";